/**
 * Settings Layout Component
 * Provides sub-navigation for settings section with nested outlet
 */

import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Building, Users } from 'lucide-react';
import { ROUTES } from '../../routes';

interface SettingsSubNavItem {
  label: string;
  path: string;
  icon: React.ElementType;
  description: string;
}

const settingsSubNav: SettingsSubNavItem[] = [
  {
    label: 'Perusahaan',
    path: ROUTES.SETTINGS_COMPANIES,
    icon: Building,
    description: 'Kelola perusahaan & rekening'
  },
  {
    label: 'Pengguna',
    path: ROUTES.SETTINGS_USERS,
    icon: Users,
    description: 'Kelola pengguna & akses (RBAC)'
  }
];

export const AdminLayout: React.FC = () => {
  const location = useLocation();

  return (
    <div className="space-y-6">
      {/* Sub-navigation tabs */}
      <div className="bg-white p-2 rounded-xl border border-gray-200 shadow-sm inline-flex flex-wrap gap-1">
        {settingsSubNav.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname.startsWith(item.path);
          
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-indigo-600 text-white shadow-sm'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`}
              title={item.description}
            >
              <Icon className="w-4 h-4 mr-2" />
              {item.label}
            </NavLink>
          );
        })}
      </div>

      {/* Nested content area */}
      <div className="animate-fade-in-up">
        <Outlet />
      </div>
    </div>
  );
};;
